import React, { createContext, useEffect, useReducer, useContext } from "react";
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";
import { getPathName } from "../../../common/utils/utilsFunc";

export const EstaSinLuzContext = createContext();
export const ACTIONS = {
  SET_ESTA_SIN_LUZ: "SET_ESTA_SIN_LUZ",
  SET_IDCTACTO: "SET_IDCTACTO",
  SET_FORMCONT: "SET_FORMCONT",
  SET_RESPONSE_FORMCONT: "SET_RESPONSE_FORMCONT",
  SET_CURRENT_PAGE: "SET_CURRENT_PAGE",
  SET_TIPO_PRESENTACION: "SET_TIPO_PRESENTACION",
  SET_WEB_CONTENT_TEXT_INFO: "SET_WEB_CONTENT_TEXT_INFO",

};
const initialState = {
  idCtaCto: "",
  estaSinLuz: [],
  formCont: "",
  responseFormCont: {},
  currentPage: 0,
  tipoPresentacion: {},
  webContentTextInfo: "",

};
const EstaSinLuzReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_ESTA_SIN_LUZ: {
      return {
        ...state,
        estaSinLuz: action.payload,
      };
    }
    case ACTIONS.SET_IDCTACTO: {
      return {
        ...state,
        idCtaCto: action.payload,
      };
    }
    case ACTIONS.SET_FORMCONT: {
      return {
        ...state,
        formCont: action.payload,
      };
    }
    case ACTIONS.SET_RESPONSE_FORMCONT: {
      return {
        ...state,
        responseFormCont: action.payload,
      };
    }
    case ACTIONS.SET_CURRENT_PAGE: {
      return {
        ...state,
        currentPage: action.payload,
      };
    }
    case ACTIONS.SET_TIPO_PRESENTACION: {
      return {
        ...state,
        tipoPresentacion: action.payload,
      };
    }
    case ACTIONS.SET_WEB_CONTENT_TEXT_INFO: {
      return {
        ...state,
        webContentTextInfo: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
const EstaSinLuzContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);

  const [state, dispatch] = useReducer(EstaSinLuzReducer, initialState);
  useEffect(() => {
    if (state.idCtaCto && getPathName() === 'estas-sin-luz') {
      LiferayService.getEstaSinLuz(properties.base_url_api, state.idCtaCto, properties.codigo_empresa, properties.url_ws_empresa)
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_ESTA_SIN_LUZ,
          });
        })
    }
  }, [state.idCtaCto]);

  useEffect(() => {
    if (state.formCont && getPathName() === 'estas-sin-luz') {
      LiferayService.postFormCont(properties.base_url_api, state.formCont, properties.url_ws_empresa, properties.estas_sin_luz_content_correo)
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_RESPONSE_FORMCONT,
          });
        })
    }
  }, [state.formCont]);

  useEffect(() => {
    if (getPathName() === 'estas-sin-luz') {
      LiferayService.getTipoPresentacion(properties.base_url_api)
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_TIPO_PRESENTACION,
          });
        })
    }
  }, []);

  React.useEffect(() => {
    if(state.currentPage === 2 || state.currentPage === 0){
      if (properties.web_content_info_update_of_contact_information.trim()) {
        LiferayService.getWebContent(properties.base_url_api, properties.web_content_info_update_of_contact_information.trim())
          .then((response) => {
            dispatch({
              payload: response,
              type: ACTIONS.SET_WEB_CONTENT_TEXT_INFO,
            });
          })
        }
    }


  }, [state.currentPage])

  return (
    <EstaSinLuzContext.Provider value={[state, dispatch]}>
      {children}
    </EstaSinLuzContext.Provider>
  );
};
export default EstaSinLuzContextProvider;